import { render, staticRenderFns } from "./UploadCertificationDialog.vue?vue&type=template&id=e21a5bac&scoped=true&"
import script from "./UploadCertificationDialog.vue?vue&type=script&lang=js&"
export * from "./UploadCertificationDialog.vue?vue&type=script&lang=js&"
import style0 from "./UploadCertificationDialog.vue?vue&type=style&index=0&id=e21a5bac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21a5bac",
  null
  
)

export default component.exports